import { alpha, createTheme } from '@mui/material/styles';

export const soulWiseTheme = {
  palette: {
    white10: alpha('#fff', 0.1),
    white20: alpha('#fff', 0.2),
    white80: alpha('#fff', 0.8),
    sea70: '#144452',
    sea80: '#0f333d',
    sea90: '#0a2229',
    sea95: '#051114',
    greenLight: '#52e090',
    greenLight15: alpha('#52e090', 0.15),
    yellowLight: '#FEFFED',
    warning: {
      main: '#FDC620',
    },
    info: {
      main: '#52e090',
    },
    error: {
      main: '#e05252',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily:
      "'DM Sans', 'Noto Sans Arabic', -apple-system, BlinkMacSystemFont, 'Inter', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  },
};

export const muiTheme = createTheme({
  ...soulWiseTheme,
  spacing: [0, 4, 8, 16, 32, 64],
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});
